// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart_labels__tCXAr {
  display: flex;
  margin-left: 44px; }

.chart_label__Wc7Sh {
  display: flex;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: right;
  letter-spacing: 0.1px;
  color: var(--LowEmphasis); }

.chart_label__Wc7Sh:not(:first-child) {
  margin-left: 30px; }

.chart_labelStock__jjNcd {
  margin-right: 10px;
  width: 10px;
  height: 10px; }

.chart_labelInStock__vyHMJ {
  background: var(--Green); }

.chart_labelLowStock__qDLWh {
  background: var(--StockOrange); }

.chart_labelOutStock__6Dxl5 {
  background: var(--StockRed); }
`, "",{"version":3,"sources":["webpack://./src/pages/inventory/components/Chart/chart.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,iBAAiB,EAAA;;AAGnB;EACE,aAAa;EC0Db,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDzDjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EAErB,yBAAyB,EAAA;;AAG3B;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,wBAAwB,EAAA;;AAG1B;EACE,8BAA8B,EAAA;;AAGhC;EACE,2BAA2B,EAAA","sourcesContent":["@import '../../../../styles/media.scss';\n@import '../../../../styles/fonts.scss';\n\n.labels {\n  display: flex;\n  margin-left: 44px;\n}\n\n.label {\n  display: flex;\n  @include caption;\n\n  display: flex;\n  align-items: center;\n  text-align: right;\n  letter-spacing: 0.1px;\n\n  color: var(--LowEmphasis);\n}\n\n.label:not(:first-child) {\n  margin-left: 30px;\n}\n\n.labelStock {\n  margin-right: 10px;\n  width: 10px;\n  height: 10px;\n}\n\n.labelInStock {\n  background: var(--Green);\n}\n\n.labelLowStock {\n  background: var(--StockOrange);\n}\n\n.labelOutStock {\n  background: var(--StockRed);\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labels": `chart_labels__tCXAr`,
	"label": `chart_label__Wc7Sh`,
	"labelStock": `chart_labelStock__jjNcd`,
	"labelInStock": `chart_labelInStock__vyHMJ`,
	"labelLowStock": `chart_labelLowStock__qDLWh`,
	"labelOutStock": `chart_labelOutStock__6Dxl5`
};
export default ___CSS_LOADER_EXPORT___;
